import '@/utils/log';

import { notification } from 'antd';
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { enableMapSet } from 'immer';
import VConsole from 'vconsole';

import { isMobile } from 'react-device-detect';
import { initReactGA } from './utils/analytics';
import { initSentry } from './utils/sentry';
enableMapSet();

initSentry();
initReactGA();

notification.config({
  duration: 9,
  placement: 'topRight',
  top: 70,
});

// bigNumber decimal config
BigNumber.config({ DECIMAL_PLACES: 18 });

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime);

if (import.meta.env.VITE_APP_ENABLE_VCONSOLE === 'true' && isMobile) {
  new VConsole();
}

declare global {
  interface BigInt {
    toJSON(): string;
  }
}

BigInt.prototype.toJSON = function () {
  return this.toString();
};
